export function rolldate() {
    if (typeof Rolldate !== 'undefined') {
        new Rolldate({
            el: '#birthday-picker',
            format: 'YYYY MM DD',
            beginYear: 1900,
            endYear: 2100,
            value: '1999 03 02',
            init: function () {
                console.log('Init');
            },
            moveEnd: function (scroll) {
                console.log(scroll)
                console.log('Scroll End');
            },
            confirm: function (date) {
                console.log(date)
                console.log('Confirmed');
            },
            cancel: function () {
                console.log('Canceled');
            }
        })

        new Rolldate({
            el: '#birthtime-picker',
            format: 'HH:mm PMAM',
            value: '11:00 AM',
            init: function () {
                console.log('Init');
            },
            moveEnd: function (scroll) {
                console.log(scroll)
                console.log('Scroll End');
            },
            confirm: function (date) {
                console.log(date)
                console.log('Confirmed');
            },
            cancel: function () {
                console.log('Canceled');
            }
        })
    }
}
